const Data = [
  {
    name: "Amanda",
    location: "",
    image: "../images/reviews/5.jpg",
    quote: "Thank you so much for doing all our wedding hair, we are all so pleased.  "
    + "You're very talented Amy"
  },
  {
    name: "Holly",
    location: "The Fennes",
    image: "../images/reviews/8.jpg",
    quote: "Everything you did was just magical"
  },
  {
    name: "Hannah",
    location: "Royal Hotel Clacton",
    image: "../images/reviews/6.jpg",
    quote: "Thank you so much.  You're amazing.  I love my hair and so did everyone else "
  },
  {
    name: "Hannah (Mother of Bride)",
    location: "",
    image: "../images/reviews/7.jpg",
    quote: "Thank you so much for the beautiful hairstyles.  We all loved them.  "
    + "Thank you for being part of my daughters day"
  },
  {
    name: "Kat",
    location: "Whittlebury Hall",
    image: "../images/reviews/2.jpg",
    quote: "Thank you so much to Amy for doing mine and my bridesmaids hair on my wedding day "
    + "in December, fabulous experience from start to finish"
  },
  {
    name: "Laura",
    location: "Houchins Barn",
    image: "../images/reviews/3.jpg",
    quote: "Amy did my wedding hair, flower girls and 2 bridesmaids.  Throughout the day I had "
    + "so many people commenting how lovely my hair was"
  },    
  {
    name: "Emily and Rebecca",
    location: "The Fennes",
    image: "../images/reviews/1.jpg",
    quote: "Amy was fantastic - from the trial to the day she was professional, friendly and "
    + "happy to work around what we pictured. "
    + "By the time we got to the venue she was already set up and ready to go.  "
    + "She was able to add in the flowers we wanted and they stayed in place the whole day! "
  },
  {
    name: "Kelly",
    location: "Maison Talbooth",
    image: "../images/reviews/4.jpg",
    quote: "I got married in October and hadn't had the chance to thank you for mine and my bridesmaids stunning hair styles.  "
    + "On the day arrival was prompt and just got on with it (which is just what you want on the morning of your big day). "
    + " In total I had 6 bridesmaids all wanting different looks but still in keeping with the style.  "
    + "As for my hair Amy absolutely smashed it.  She achieved everything wanted (if not more) the whole process from "
    + "trials to colour was spot on I can not thank you enough"
  },
  {
    name: "Kayleigh Brooks-Harper (Hair)",
    location: "The Venue at Kersey Mill",
    image: "../images/reviews/10.jpg",
    quote: "For our hair, she was thorough and quick managing not only my hair, but 6 "
    + "bridesmaids and my mum with no hassle, drama or complications. She honestly rocked "
    + "at helping make our wedding perfect and is absolutely a wedding fairy godmother! 🤍"
  },
];

export default Data;